<template>
  <vx-card>
    <div class="vx-row">
      <div class="vx-col lg:w-6/12 w-full">
        <vs-button icon-pack="feather" icon="icon-map" class="mr-4 mb-4 w-full" @click="popupActiveInitial = true">1.
          The Contact Point
        </vs-button>
      </div>
      <div class="vx-col lg:w-6/12 w-full">
        <vs-button icon-pack="feather" icon="icon-zap" class="mr-4 mb-4 w-full" @click="popupActiveQuery = true">2. The
          XYLO database
        </vs-button>
      </div>
    </div>
    <div class="mt-5">
      <gmap-map :center="center" :zoom="zoom" style="width: 100%; height: 600px">
        <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen"
          @closeclick="infoWinOpen = false">
          {{ infoContent }}
        </gmap-info-window>
        <gmap-marker :key="i" v-for="(m, i) in markers2" :position="m.position" :clickable="true"
          @click="toggleInfoWindow(m, i)"></gmap-marker>
        <gmap-marker :key="i" v-for="(m, i) in markers1" :position="m.position" :clickable="true"
          @click="toggleInfoWindow(m, i)"
          icon="http://maps.google.com/mapfiles/kml/paddle/blu-circle.png"></gmap-marker>
      </gmap-map>
    </div>


    <div class="vx-row mt-8">
      <div class="vx-col lg:w-12/12 w-full">
        <vs-table :data="datadata" class="table-dark-inverted" stripe search>
          <template slot="thead">
            <vs-th>Name</vs-th>
            <vs-th>Place</vs-th>
            <vs-th>Distance</vs-th>
            <vs-th>Volume</vs-th>
            <vs-th>Zoom</vs-th>
          </template>
          <template slot-scope="{ data }">


            <vs-tr :key="indextrrr" v-for="(trr, indextrrr) in data">
              <vs-td>
                <span> {{ trr.name }} </span>
              </vs-td>
              <vs-td>
                <span> {{ trr.place }} </span>
              </vs-td>
              <vs-td>
                <span v-if="parseFloat(trr.distance) < 2000"> {{ trr.distance }} km</span>
                <span v-else style="color: red;">No contact point selected</span>
              </vs-td>
              <vs-td v-if="radiovolumeordered === 'null2'">
                <span> {{ trr.volume }} m3</span>
              </vs-td>
              <vs-td v-else-if="radiovolumeordered == '100' && parseFloat(trr.volume) >= 100">
                <span> {{ trr.volume }} m3</span>
              </vs-td>
              <vs-td v-else-if="radiovolumeordered == '50' && parseFloat(trr.volume) >= 50">
                <span> {{ trr.volume }} m3</span>
              </vs-td>
              <vs-td v-else-if="radiovolumeordered == '25' && parseFloat(trr.volume) >= 25">
                <span> {{ trr.volume }} m3</span>
              </vs-td>
              <vs-td v-else>
                <span style="color: red;">Lower than requested</span>
              </vs-td>
              <vs-td>
              <vs-button
                        @click="zoomOnMap(trr.lat,trr.lng)"
                      >Zoom</vs-button>
              </vs-td>

            </vs-tr>
          </template>
        </vs-table>
      </div>
    </div>

    <vs-popup class="holamundo" title="Initial Point Research" :active.sync="popupActiveInitial">
      <div class="p-6">
        <div class="vx-row w-full">
          <div class="vx-col w-full">
            <vs-select autocomplete v-model="dataIdCountry" label="Country" class="mt-0 w-full" name="country">
              <vs-select-item :key="item.country_code" :value="item.country_code" :text="item.name_en"
                v-for="item in data_options_countries" />
            </vs-select>
          </div>
        </div>
        <div class="vx-row w-full mt-4">
          <div class="vx-col w-full">
            <vs-input label="Place [AND/OR] Postal Code" v-model="dataSearchPlaceName" @input="submitSearchInitialPoint"
              class="mt-0 w-full" />
          </div>
        </div>
        <div class="vx-row w-full mt-4">
          <div class="vx-col w-full">
            <vs-select v-model="dataIdPlace" @change="getDataFromPlaceId" label="Places" class="mt-0 w-full"
              name="places">
              <vs-select-item :key="item.id" :value="item.id" :text="item.place" v-for="item in data_options_places" />
            </vs-select>
          </div>
        </div>
        <vs-button icon-pack="feather" icon="icon-map" class="mt-6 mr-6" :disabled="!isFormValid"
          @click="SendInitialPointOnMap()">Search</vs-button>
      </div>
    </vs-popup>

    <vs-popup class="popup-dem" title="Query the database" :active.sync="popupActiveQuery">
      <div class="my-4">
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full">
            <div>
              <h6 class="mb-2" v-if="radioisreseller === 'true'">1.a. Must be reseller</h6>
              <h6 class="mb-2" v-else>1. Must be reseller</h6>
              <ul class="centerx">
                <li>
                  <vs-radio color="success" v-model="radioisreseller" vs-value="true">Yes</vs-radio>
                </li>
                <li>
                  <vs-radio color="danger" v-model="radioisreseller" vs-value="false">No</vs-radio>
                </li>
                <li>
                  <vs-radio color="#c0c0c0" v-model="radioisreseller" vs-value="null0">All</vs-radio>
                </li>
              </ul>
            </div>
            <div v-if="radioisreseller === 'true'">
              <h6 class="mb-2 mt-2">1.b. Must be broker</h6>
              <ul class="centerx">
                <li>
                  <vs-radio color="success" v-model="radioisbroker" vs-value="yes">Yes</vs-radio>
                </li>
                <li>
                  <vs-radio color="success" v-model="radioisbroker" vs-value="no">No</vs-radio>
                </li>
                <li>
                  <vs-radio color="#c0c0c0" v-model="radioisbroker" vs-value="null00">All</vs-radio>
                </li>
              </ul>
            </div>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <h6 class="mb-2">2. Last order</h6>
            <ul class="centerx">
              <li>
                <vs-radio color="warning" v-model="radiolastorder" vs-value="36">&lt; 36 Months</vs-radio>
              </li>
              <li>
                <vs-radio color="warning" v-model="radiolastorder" vs-value="24">&lt; 24 Months</vs-radio>
              </li>
              <li>
                <vs-radio color="warning" v-model="radiolastorder" vs-value="18">&lt; 18 Months</vs-radio>
              </li>
              <li>
                <vs-radio color="warning" v-model="radiolastorder" vs-value="12">&lt; 12 Months</vs-radio>
              </li>
              <li>
                <vs-radio color="danger" v-model="radiolastorder" vs-value="6">&lt; 6 Months</vs-radio>
              </li>
              <li>
                <vs-radio color="success" v-model="radiolastorder" vs-value="3">&lt; 3 Months</vs-radio>
              </li>
              <li>
                <vs-radio color="success" v-model="radiolastorder" vs-value="1">&lt; 1 Month</vs-radio>
              </li>
              <li>
                <vs-radio color="#c0c0c0" v-model="radiolastorder" vs-value="null1">Since forever</vs-radio>
              </li>
            </ul>
          </div>
        </div>
        <hr class="mt-5 w-full" style="border: 1px solid #c0c0c0" />
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full mt-4">
            <h6 class="mb-2">3. Sum of Volume ordered</h6>
            <ul class="centerx">
              <li>
                <vs-radio color="warning" v-model="radiovolumeordered" vs-value="100">&gt; 100m3</vs-radio>
              </li>
              <li>
                <vs-radio color="danger" v-model="radiovolumeordered" vs-value="50">&gt; 50m3</vs-radio>
              </li>
              <li>
                <vs-radio color="success" v-model="radiovolumeordered" vs-value="25">&gt; 25m3</vs-radio>
              </li>
              <li>
                <vs-radio color="#c0c0c0" v-model="radiovolumeordered" vs-value="null2">All</vs-radio>
              </li>
            </ul>
          </div>
          <div class="vx-col md:w-1/2 w-full mt-4">
            <h6 class="mb-2">4. Distance from contact point</h6>
            <ul class="centerx">
              <li>
                <vs-radio color="warning" v-model="radiodistancefromcontactpoint" vs-value="501">&lt; 500 km</vs-radio>
              </li>
              <li>
                <vs-radio color="warning" v-model="radiodistancefromcontactpoint" vs-value="401">&lt; 400 km</vs-radio>
              </li>
              <li>
                <vs-radio color="warning" v-model="radiodistancefromcontactpoint" vs-value="301">&lt; 300 km</vs-radio>
              </li>
              <li>
                <vs-radio color="warning" v-model="radiodistancefromcontactpoint" vs-value="201">&lt; 200 km</vs-radio>
              </li>
              <li>
                <vs-radio color="warning" v-model="radiodistancefromcontactpoint" vs-value="101">&lt; 100 km</vs-radio>
              </li>
              <li>
                <vs-radio color="danger" v-model="radiodistancefromcontactpoint" vs-value="51">&lt; 50 km</vs-radio>
              </li>
              <li>
                <vs-radio color="success" v-model="radiodistancefromcontactpoint" vs-value="26">&lt; 25 km</vs-radio>
              </li>
              <li>
                <vs-radio color="#c0c0c0" v-model="radiodistancefromcontactpoint" vs-value="null3">All</vs-radio>
              </li>
            </ul>
          </div>
        </div>

        <br />

        <vs-button icon-pack="feather" icon="icon-map" class="mt-6 mr-6" :disabled="!isFormValid"
          @click="GetDataBaseQuery()">Search</vs-button>
      </div>
    </vs-popup>
  </vx-card>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import axios from "@/axios.js";
import vSelect from "vue-select";

export default {
  data() {
    return {
      radioisreseller: "null0",
      radiolastorder: "null1",
      radiovolumeordered: "null2",
      radiodistancefromcontactpoint: "null3",
      radioisbroker: "null00",

      options: {
        apiKey: "AIzaSyDW5Ik0oyDhx0gaCjOyWhMehsBcuSOPqJo",
        deepSearch: true,
      },
      orange: "http://maps.google.com/mapfiles/kml/paddle/orange-circle.png",
      yellow: "http://maps.google.com/mapfiles/kml/paddle/ylw-circle.png",
      blue: "http://maps.google.com/mapfiles/kml/paddle/blu-circle.png",
      dataInitialPointLat: "",
      dataInitialPointLng: "",
      dataIdPlace: "",
      data_options_places: [],
      dataIdCountry: "",
      dataSearchPlaceName: "",
      data_options_countries: [],
      popupActiveQuery: false,
      popupActiveInitial: false,
      center: { lat: 47.376332, lng: 8.547511 },
      zoom: 4.8,
      infoContent: "",
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      datadata : [],
      testing: "Hello World",
      //optional: offset infowindow so it visually sits nicely on top of our marker
      infoOptions: {
        pixelOffset: { width: 0, height: -35 },
      },
      markers1: [],
      markers2: [],
    };
  },
  methods: {
    zoomOnMap(lat,lng)
    {
      this.center.lat = lat
      this.center.lng = lng
      this.zoom = 9
    },
    buildTheSql() {
      let sqlreq = " ";

      if (this.radioisreseller === "null0") {
        this.radioisbroker = "null00"
      }
      else if (this.radioisreseller === "true")
        sqlreq = sqlreq + " AND people.isreseller";
      else if (this.radioisreseller === "false") {
        sqlreq = sqlreq + " AND NOT (people.isreseller = false OR people.isbroker IS null)";
        this.radioisbroker = "null00"
      }

      if (this.radioisbroker === "null00");
      else if (this.radioisbroker === "yes")
        sqlreq =sqlreq+ " AND people.isbroker";
      else if (this.radioisbroker === "no")
        sqlreq = sqlreq+" AND (people.isbroker = false OR people.isbroker IS null)";

      if (this.radiolastorder === "null1");
      else if (this.radiolastorder === "12")
        sqlreq =
          sqlreq +
          " AND operations.date >= CURRENT_DATE - INTERVAL '12 months'";
      else if (this.radiolastorder === "6")
        sqlreq =
          sqlreq + " AND operations.date >= CURRENT_DATE - INTERVAL '6 months'";
      else if (this.radiolastorder === "3")
        sqlreq =
          sqlreq + " AND operations.date >= CURRENT_DATE - INTERVAL '3 months'";
      else if (this.radiolastorder === "1")
        sqlreq =
          sqlreq + " AND operations.date >= CURRENT_DATE - INTERVAL '1 month'";

      /* if (this.radiovolumeordered == "null2") ;
      else if (this.radiovolumeordered == "100") sqlreq = sqlreq+ " AND volume >= 100";
      else if (this.radiovolumeordered == "50") sqlreq = sqlreq+ " AND volume >= 50";
      else if (this.radiovolumeordered == "25") sqlreq = sqlreq+ " AND volume >= 25";*/

      if (this.radiodistancefromcontactpoint === "null3");
      else if (this.radiodistancefromcontactpoint === "501")
        sqlreq =
          sqlreq +
          " AND (get_distance_2points(" +
          this.dataInitialPointLat +
          "," +
          this.dataInitialPointLng +
          ",places.latitude,places.longitude) <= 500)";
      else if (this.radiodistancefromcontactpoint === "401")
        sqlreq =
          sqlreq +
          " AND (get_distance_2points(" +
          this.dataInitialPointLat +
          "," +
          this.dataInitialPointLng +
          ",places.latitude,places.longitude) <= 400)";
      else if (this.radiodistancefromcontactpoint === "301")
        sqlreq =
          sqlreq +
          " AND (get_distance_2points(" +
          this.dataInitialPointLat +
          "," +
          this.dataInitialPointLng +
          ",places.latitude,places.longitude) <= 300)";
      else if (this.radiodistancefromcontactpoint === "201")
        sqlreq =
          sqlreq +
          " AND (get_distance_2points(" +
          this.dataInitialPointLat +
          "," +
          this.dataInitialPointLng +
          ",places.latitude,places.longitude) <= 200)";
      else if (this.radiodistancefromcontactpoint === "101")
        sqlreq =
          sqlreq +
          " AND (get_distance_2points(" +
          this.dataInitialPointLat +
          "," +
          this.dataInitialPointLng +
          ",places.latitude,places.longitude) <= 100)";
      else if (this.radiodistancefromcontactpoint === "51")
        sqlreq =
          sqlreq +
          " AND (get_distance_2points(" +
          this.dataInitialPointLat +
          "," +
          this.dataInitialPointLng +
          ",places.latitude,places.longitude) <= 50)";
      else if (this.radiodistancefromcontactpoint === "26")
        sqlreq =
          sqlreq +
          " AND (get_distance_2points(" +
          this.dataInitialPointLat +
          "," +
          this.dataInitialPointLng +
          ",places.latitude,places.longitude) <= 25)";

      return sqlreq;
    },
    displayMarkers2(data) {
      data.forEach((e) => {
        let obj = {
          position: {
            lat: parseFloat(e.lat),
            lng: parseFloat(e.lng),
          },
          infoText: e.name + " → distance: " + e.distance + " km → volume : " + e.volume + " m3",
        };
        if (this.radiovolumeordered == "null2") this.markers2.push(obj);
        else if (this.radiovolumeordered == "100" && e.volume >= 100) this.markers2.push(obj);
        else if (this.radiovolumeordered == "50" && e.volume >= 50) this.markers2.push(obj);
        else if (this.radiovolumeordered == "25" && e.volume >= 25) this.markers2.push(obj);

      });
      this.popupActiveQuery = false;
    },
    async GetDataBaseQuery() {
      //alert(this.buildTheSql())
      this.markers2 = [];
      if (!this.dataInitialPointLat) this.dataInitialPointLat = 0;
      if (!this.dataInitialPointLng) this.dataInitialPointLng = 0;
      axios
        .get(
          "/person/clientmap/" +
          this.buildTheSql() +
          "/" +
          this.dataInitialPointLat +
          "/" +
          this.dataInitialPointLng
        )
        .then((response) => {
          //this.markers2 = response.data;
          this.datadata = response.data
          this.displayMarkers2(response.data);
        });
      this.popupActiveQuery = false;
    },
    async SendInitialPointOnMap() {
      let obj = {
        position: {
          lat: parseFloat(this.dataInitialPointLat),
          lng: parseFloat(this.dataInitialPointLng),
        },
        infoText: "The Contact Point → " + this.dataPlace,
      };
      this.markers1 = [];
      this.markers1.push(obj);
      this.popupActiveInitial = false;
      this.GetDataBaseQuery();
    },
    getDataFromPlaceId() {
      axios.get("/place/" + this.dataIdPlace).then((response) => {
        this.dataCountry = response.data.country.name_en;
        if (response.data.province)
          this.dataRegion = response.data.region + "/" + response.data.province;
        else this.dataRegion = response.data.region;

        this.dataPlace = response.data.place_name;
        this.dataPostalCode = response.data.postal_code;
        this.dataInitialPointLat = response.data.latitude;
        this.dataInitialPointLng = response.data.longitude;
      });
    },
    async getOptionsCountries() {
      axios.get("/countrieslist").then((response) => {
        this.data_options_countries = [...response.data];
      });
    },
    async submitSearchInitialPoint() {
      var string = this.dataSearchPlaceName.split(" ");
      var url = null;
      if (this.dataIdCountry) {
        if (string.length > 1) {
          if (string[0] === "" || string[0] === null) {
            url =
              "/placeslist/" +
              this.dataIdCountry +
              "/ /" +
              string[1].trim();
          } else if (string[1] === null) {
          } else {
            url =
              "/placeslist/" +
              this.dataIdCountry +
              "/" +
              string[0].trim() +
              "/" +
              string[1].trim();
          }
        } else {
          url =
            "/placeslist/" + this.dataIdCountry + "/ /" + string[0].trim();
        }
        axios.get(url).then((response) => {
          if (response.data[0] === undefined) {
            //("SECOND LOOP")
            url =
              "/placeslist/" +
              this.dataIdCountry +
              "/" +
              string[0].trim() +
              "/";
            axios.get(url).then((response) => {
              this.data_options_places = [...response.data];
              this.dataIdPlace = response.data[0].id;
            });
          } else {
            this.data_options_places = [...response.data];
            this.dataIdPlace = response.data[0].id;
          }
        });
      } else {
        if (string.length > 1) {
          if (string[0] === "" || string[0] === null) {
            url = "/places/ /" + string[1].trim();
          } else if (string[1] === null) {
          } else {
            url = "/places/" + string[0].trim() + "/" + string[1].trim();
          }
        } else {
          url = "/places/ /" + string[0].trim();
        }
        axios.get(url).then((response) => {
          if (response.data[0] === undefined) {
            //("SECOND LOOP")
            url = "/places/" + string[0].trim() + "/";
            axios.get(url).then((response) => {
              this.data_options_places = [...response.data];
              this.dataIdPlace = response.data[0].id;
            });
          } else {
            this.data_options_places = [...response.data];
            this.dataIdPlace = response.data[0].id;
          }
        });
      }
      // Loading Category Address
      this.dataAddressCategory = 1;
    },
    toggleInfoWindow(marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoContent = marker.infoText;

      if (this.currentMidx === idx) {
        //check if its the same marker that was selected if yes toggle
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        //if different marker set infowindow to open and reset current marker index
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },
    isFormValid() {
      return (
        !this.errors.any() &&
        /*this.dataStreet && this.dataNumber &&*/ this.dataPlace
      );
    },
  },
  created() {
    this.getOptionsCountries();
    this.radioisreseller = "true"
    this.radioisbroker = "null00"
    this.buildTheSql();
    this.GetDataBaseQuery();
  },
};
</script>
